angular.module('myApp')

.factory('commonApiFactory', [
  '$routeParams', '$timeout',
  'commonAuthFactory', 'commonFactory', 'Const',
  function (
    $routeParams, $timeout,
    commonAuthFactory, commonFactory, Const
  ) {
    const checkKeyToken = () => {
      if (!localStorage.getItem(Const.LSKEY_USER_ACCESS_KEY_ID) ||
       !localStorage.getItem(Const.LSKEY_USER_SECRET_ACCESS_KEY) ||
       !localStorage.getItem(Const.LSKEY_USER_SESSION_TOKEN)) {
        return false;
      }
      return true;
    };

    const createApigClient = () => apigClientFactory.newClient({
      'accessKey': localStorage.getItem(Const.LSKEY_USER_ACCESS_KEY_ID),
      'secretKey': localStorage.getItem(Const.LSKEY_USER_SECRET_ACCESS_KEY),
      'sessionToken': localStorage.getItem(Const.LSKEY_USER_SESSION_TOKEN),
      'region': Const.REGION
    });

    // Credentialをリフレッシュする
    const refreshOnCredentials = () => new Promise((resolve, reject) =>
    commonAuthFactory.refreshCredentials()
    .then(loginResult => {
      return resolve(commonAuthFactory.getCredentialsForAPI(loginResult, localStorage.getItem(Const.LSAPP_ROLE)));
    })
    .catch(error => {
      commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_REFRESH_ERROR, 5000, true);
      return reject(error);
    }));

    // Credentialをリフレッシュ後、対象のコールバックを実行する
    const callTargetApiAgain = (callBack, params, bodies, additionalParams) => new Promise((resolve, reject) => {
      console.log('Retry...');
      callBack(params, bodies, additionalParams)
      .then(result => {
        return resolve(result);
      })
      .catch(error => {
        return reject(error);
      });
    });

    /*
      ADMIN COMPANIES ME / GET
    */
    this.getAdminCompaniesMeSchools = () => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = {};
      const body = {};
      const additionalParams = {};

      apigClient.adminCompaniesMeSchoolsGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      ADMIN SCHOOL COURSES  / GET
    */
    this.getAdminSchoolsSchoolIdCourses = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.adminSchoolsSchoolIdCoursesGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      ADMIN SCHOOL MEMBERS  / GET
    */
    this.getAdminSchoolsSchoolIdMembers = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.adminSchoolsSchoolIdMembersGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      ADMIN SCHOOL STAFFS  / GET
    */
    this.getAdminSchoolsSchoolIdStaffs = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.adminSchoolsSchoolIdStaffsGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBERS ME / GET
    */
    this.getMembersMe = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.membersMeGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBERS ME / PUT
    */
    this.putMembersMe = bodies => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = {};
      const body = bodies;
      const additionalParams = {};

      apigClient.membersMePut(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.membersMePut, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBERS ME MESSAGES
    */
    this.getMembersMeMessages = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.membersMeMessagesGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBERS ME LESSONS
    */
    this.getMembersMeLessons = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.membersMeLessonsGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBERS ME SHOTS
    */
    this.getMembersMeShots = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.membersMeShotsGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.membersMeShotsGet, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBERS ME COURSE LESSONS
    */
    this.getMembersMeCoursesCourseIdLessons = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.membersMeCoursesCourseIdLessonsGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      STAFFS ME
    */
    this.getStaffsMe = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.staffsMeGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBER
    */
    this.getMembersMemberId = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.membersMemberIdGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBER MESSAGES / GET
    */
    this.getMembersMemberIdMessages = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.membersMemberIdMessagesGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBER MESSAGES / POST
    */
    this.postMembersMemberIdMessages = (params, bodies) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = bodies;
      const additionalParams = {};

      apigClient.membersMemberIdMessagesPost(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.membersMemberIdMessagesPost, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBER MESSAGES / PUT
    */
    this.putMembersMemberIdMessages = (params, bodies) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = bodies;
      const additionalParams = {};

      apigClient.membersMemberIdMessagesPut(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.membersMemberIdMessagesPut, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBER LESSONS
    */
    this.getMembersMemberIdLessons = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.membersMemberIdLessonsGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBER SHOTS
    */
    this.getMembersMemberIdShots = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.membersMemberIdShotsGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.membersMemberIdShotsGet, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      STAFF ME COURSES
    */
    this.getStaffsMeCourses = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.staffsMeCoursesGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      COURSE MEMBERS
    */
    this.getCoursesCourseIdMembers = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.coursesCourseIdMembersGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBER COURSE LESSONS
    */
    this.getMembersMemberIdCoursesCourseIdLessons = params => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.membersMemberIdCoursesCourseIdLessonsGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBER FEEDBACKSHEET / GET
    */
    this.getMembersMemberIdFeedbackSheet = (params) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.membersMemberIdFeedbackSheetGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      COMPANY ADMIN SCHOOL ADMIN PASSWORD RESET / POST
    */
    this.postAdminCompaniesMeSchoolsSchoolIdAdminPasswordReset = (params, bodies) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = bodies;
      const additionalParams = {};

      apigClient.adminCompaniesMeSchoolsSchoolIdAdminPasswordResetPost(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.adminCompaniesMeSchoolsSchoolIdAdminPasswordResetPost, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      SCHOOL ADMIN STAFF PASSWORD RESET / POST
    */
    this.postAdminSchoolsSchoolIdStaffsStaffIdPasswordReset = (params, bodies) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = bodies;
      const additionalParams = {};

      apigClient.adminSchoolsSchoolIdStaffsStaffIdPasswordResetPost(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.adminSchoolsSchoolIdStaffsStaffIdPasswordResetPost, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      SCHOOL ADMIN MEMBER PASSWORD RESET / POST
    */
    this.postAdminSchoolsSchoolIdMembersMemberIdPasswordReset = (params, bodies) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = bodies;
      const additionalParams = {};

      apigClient.adminSchoolsSchoolIdMembersMemberIdPasswordResetPost(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.adminSchoolsSchoolIdMembersMemberIdPasswordResetPost, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBER PASSWORD RESET / POST
    */
    this.postMembersPasswordReset = bodies => new Promise((resolve, reject) => {
      // 認証情報無しで呼び出し
      const apigClient = apigClientFactory.newClient();

      const param = {};
      const body = bodies;
      const additionalParams = {};

      apigClient.membersPasswordResetPost(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          return reject('API call failed.');
        }
      });
    });

    /*
      MEMBER VIDEO / POST
    */
    this.postMembersVideos = (params, bodies) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = bodies;
      const additionalParams = {};

      apigClient.membersMemberIdVideosPost(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.membersMemberIdVideosPost, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    this.postMembersVideosByVideoId = (params, bodies) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = bodies;
      const additionalParams = {};

      apigClient.membersMemberIdVideosPostByVideoId(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.membersMemberIdVideosPost, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBER VIDEOS / GET
    */
    this.getMembersMemberIdVideos = (params) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.membersMemberIdVideosGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      ME VIDEO / GET
    */
    this.getMembersMeVideos = (params) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.membersMeVideosGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            location.reload();
            return reject(Const.SSAPP_HAS_REFRESH_OK);
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBER VIDEO / PUT
    */
    this.putVideosVideoId = (params, bodies) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = bodies;
      const additionalParams = {};

      apigClient.videosVideoIdPut(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.videosVideoIdPut, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBER VIDEO / DELETE
    */
    this.deleteVideosVideoId = (params) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.videosVideoIdDelete(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.videosVideoIdDelete, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      MEMBER VIDEO / GET
    */
    this.getVideosVideoId = (params) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.videosVideoIdGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.videosVideoIdGet, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      SCHOOL VIDEOS / POST
    */
    this.postSchoolsSchoolIdVideos = (params, bodies) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = bodies;
      const additionalParams = {};

      apigClient.schoolsSchoolIdVideosPost(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.schoolsSchoolIdVideosPostRequest, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      SCHOOL VIDEOS / GET
    */
    this.getSchoolsSchoolIdVideos = (params, bodies) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = bodies;
      const additionalParams = {};

      apigClient.schoolsSchoolIdVideosGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.schoolsSchoolIdVideosGetRequest, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });
    /*
      SCHOOL VIDEOS SUMMARY
    */
    this.getSchoolsSchoolIdVideosSummary = (params, bodies) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = bodies;
      const additionalParams = {};

      apigClient.schoolsSchoolIdVideosSummaryGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.schoolsSchoolIdVideosSummaryGetRequest, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      SCHOOL VIDEOS BACKLOG
    */
    this.getSchoolsSchoolIdMembersVideosBacklogsMembers = (params, bodies) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = bodies;
      const additionalParams = {};

      apigClient.schoolsSchoolIdMembersVideosBacklogsMembersGet(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.schoolsSchoolIdMembersVideosBacklogsMembersGetRequest, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });

    /*
      NOTIFICATIONS VIDEOS / DELETE
    */
    this.deleteNotificationsVideosVideoId = (params) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.notificationsVideosVideoIdDelete(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.videosVideoIdDelete, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });
    /*
      NOTIFICATIONS VIDEOS / POST
    */
    this.postNotificationsVideosVideoId = (params) => new Promise((resolve, reject) => {
      // AccessKey and Token Check!
      if (!checkKeyToken()) {
        return reject('Please authenticate.');
      }
      // apiGatewayから取得したSDKを生成
      let apigClient = createApigClient();

      const param = params;
      const body = {};
      const additionalParams = {};

      apigClient.notificationsVideosVideoIdPost(param, body, additionalParams)
      .then(result => resolve(result.data))
      .catch(result => {
        if (!navigator.onLine) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
          return reject(JSON.stringify(result));
        } else if (result.response && result.response.status === 503) {
          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          return reject(result.response);
        } else if (result.response && result.response.status >= 400) {
          return reject(result.response);
        } else {
          refreshOnCredentials().then(() => {
            apigClient = createApigClient();
            return callTargetApiAgain(
              apigClient.notificationsVideosVideoIdPostRequest, param, body, additionalParams
            );
          })
          .then(result => resolve(result.data))
          .catch(error => {
            // Cognitoのrefreshエラーの場合、undefined
            if (!error) {
              console.error('Credentials refresh failed:', error);
              return reject(error);
            }
            return reject(error.response);
          });
        }
      });
    });
    return this;
  }
]);



// WEBPACK FOOTER //
// ./app/lib/common-api.es6